/* pre-order.js — WS-PREORDER. Vanilla, no libraries.
   1. Exposes window.PlentumPreorder (is(handle), tag(handle), ship, short, label) for JS-built cards (quiz, finder).
   2. Marks every pre-order line with the hidden line-item property  _Pre-order: Ships by …  by wrapping fetch() for /cart/add
      (JSON and FormData bodies), so every existing add-to-cart (PDP, cards, quick add, quiz, finder, upsell) is covered without edits.
      Subscription lines also say it is the first order.
   3. Safety net: a cart that already holds an unmarked pre-order line is repaired once with /cart/change.js.
   Which variants are on pre-order comes from the handle list in Theme settings > Pre-order; variant ids are read from /products/<handle>.js
   (cached 12 h in localStorage). */
(function () {
  'use strict';
  var el = document.getElementById('plentum-preorder');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var handles = (cfg.handles || []).filter(Boolean), PROP = '_Pre-order';
  var H = {}; handles.forEach(function (h) { H[h] = 1; });
  var api = window.PlentumPreorder = {
    on: !!cfg.on && handles.length > 0,
    ship: cfg.ship, short: cfg.short, label: cfg.label,
    is: function (h) { return !!(api.on && h && H[h]); },
    tag: function (h) { return api.is(h) ? '<span class="po-tag" data-po-tag>Pre-order</span>' : ''; },
    chip: function (h) { return api.is(h) ? '<span class="po-chip" data-po-chip><span class="po-chip__dot" aria-hidden="true"></span>Pre-order · ' + cfg.short + '</span>' : ''; }
  };
  if (!api.on) return;

  var KEY = 'plentum_po_vmap_v1', SIG = handles.join(','), TTL = 12 * 3600 * 1000, map = null, loading = null;
  function readCache() {
    try { var c = JSON.parse(localStorage.getItem(KEY)); if (c && c.sig === SIG && Date.now() - c.t < TTL) return c.m; } catch (e) { /* private mode */ }
    return null;
  }
  function loadMap() {
    if (map) return Promise.resolve(map);
    var c = readCache(); if (c) { map = c; return Promise.resolve(map); }
    if (loading) return loading;
    var plain = window.__poFetch || window.fetch.bind(window);
    loading = Promise.all(handles.map(function (h) {
      return plain('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var m = {}; list.forEach(function (p) { if (p && p.variants) p.variants.forEach(function (v) { m[v.id] = 1; }); });
      map = m;
      try { localStorage.setItem(KEY, JSON.stringify({ sig: SIG, t: Date.now(), m: m })); } catch (e) { /* ignore */ }
      return m;
    }).catch(function () { map = {}; return map; });
    return loading;
  }
  function val(sub) { return sub ? cfg.ship + ' · first order of your subscription' : cfg.ship; }
  function patchItem(it) {
    if (!it || !map || !map[it.id]) return;
    var pr = it.properties = it.properties || {};
    if (!pr[PROP]) pr[PROP] = val(!!it.selling_plan);
  }
  function patchInit(init) {
    var b = init.body;
    if (typeof b === 'string') {
      if (b.charAt(0) === '{') {
        var o = JSON.parse(b);
        if (o.items) o.items.forEach(patchItem); else if (o.id) patchItem(o);
        init.body = JSON.stringify(o);
      } else {
        var u = new URLSearchParams(b), id = +u.get('id');
        if (id && map[id] && !u.get('properties[' + PROP + ']')) { u.set('properties[' + PROP + ']', val(!!u.get('selling_plan'))); init.body = u.toString(); }
      }
    } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
      var fid = +b.get('id');
      if (fid && map[fid] && !b.get('properties[' + PROP + ']')) b.append('properties[' + PROP + ']', val(!!b.get('selling_plan')));
    }
    return init;
  }

  var orig = window.fetch;
  window.__poFetch = orig.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '', method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method === 'POST' && init && init.body != null && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      return loadMap().then(function () { try { init = patchInit(init); } catch (e) { /* send unchanged; repaired below */ } })
        .then(function () { return orig.call(window, input, init); })
        .then(function (r) { setTimeout(repair, 400); return r; });
    }
    return orig.apply(window, arguments);
  };

  /* safety net: unmarked pre-order lines get the property through /cart/change.js (by line key; the key changes after each change, so re-read) */
  var fixing = false;
  function repair(depth) {
    if (fixing) return; fixing = true;
    (function step(n) {
      window.__poFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var bad = (cart.items || []).filter(function (i) { return H[i.handle] && !(i.properties && i.properties[PROP]); })[0];
        if (!bad || n > 8) { fixing = false; return; }
        var props = Object.assign({}, bad.properties || {}); props[PROP] = val(!!bad.selling_plan_allocation);
        return window.__poFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: bad.key, quantity: bad.quantity, properties: props }) })
          .then(function () { step(n + 1); });
      }).catch(function () { fixing = false; });
    })(0);
  }
  if (cfg.fix) repair();

  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
  idle(function () { loadMap(); }, { timeout: 4000 });
})();
